var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"menu-language-prompt"}},[_c('GeneralHeader',{attrs:{"title":_vm.$t('MapLeftPanel.languagePromptTitle')},on:{"close-btn-clicked":_vm.closeView}}),_c('PowerByVacanFrame',[_c('LanguageList',{on:{"row-clicked":_vm.rowClicked}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }